import Vue from 'vue';
import VueLazyLoad from 'vue-lazyload';
import { default as VueModal } from 'vue-js-modal';
import reviewItemsComponent from '../../../components/shop/details/expremanental/reviewItems.vue';

import { initialize } from '../../../util/sentry';
initialize(Vue);

Vue.use(VueLazyLoad);
Vue.use(VueModal, { componentName: 'vue-modal' });

// mobile版detailsページでProductReviewを表示する
new Vue({
  el: '#vue-product-review',
  components: {
    'vue-review-items': reviewItemsComponent
  }
});
